module.exports = __webpack_public_path__ + "img/fake-user-1.263b5103.png";